import React from 'react';

import { CandidLogo } from './CandidLogo';
import type { Props } from './types';

/**
 * NOTE: This component is business/domain-specific and does not belong in the
 * generic UI primitives library (ui/components). It should be moved to a more
 * appropriate domain-specific location in the codebase.
 */
const ViewInCandid = ({ url, className = '' }: Props) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center text-blue-600 hover:text-blue-800 transition-colors ${className}`}>
      View in
      <CandidLogo size={16} />
    </a>
  );
};

export default React.memo(ViewInCandid);
